export default {
  state: {
    validationModal: {
      show: false,
      title: '',
      message: ''
    },
    actionModal: {
      show: false,
      success: false,
      done: false,
      doneMessage: '',
      ongoingMessage: ''
    }
  },
  mutations: {
    // Validation Modal
    showValidationModal (state, modal) {
      state.validationModal.show = true
      state.validationModal.title = modal.title
      state.validationModal.message = modal.message
    },
    closeValidationModal (state) { state.validationModal.show = false },

    // Action Modal
    showActionModal (state, message) {
      state.actionModal.show = true
      state.actionModal.done = false
      state.actionModal.success = false
      state.actionModal.ongoingMessage = message
    },
    completeActionModal (state, value) {
      state.actionModal.done = true
      state.actionModal.success = value.success
      state.actionModal.doneMessage = value.message
    },
    closeActionModal (state) { state.actionModal.show = false }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-modal.js